import React, { useState } from "react";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { CreatePopularPlaceModal } from "../../organisms/modal/CreatePopularPlaceModal";
import { usePopularPlacePage } from "./hook";
import { PopularPlace } from "../../../ducks/popular-place";
import { EditPopularPlaceModal } from "../../organisms/modal/EditPopularPlaceModal";
import { Resource, Permission } from "../../../constants/permissions";
import { usePopularPlaceToast } from "./hook";
import styled from "styled-components";
import { useResponsive } from "../../../hooks/useResponsive";

export const PopularPlacePage = () => {
  const { showToast } = usePopularPlaceToast();
  const { isMobile } = useResponsive();
  const {
    tableHeaders,
    popularPlaces,
    handleCloseCreateModal,
    handleCloseEditModal,
    handleOpenCreateModal,
    handleOpenEditModal,
    isCreateModalOpen,
    isEditModalOpen,
    handleRowDelete,
    refetchPopularPlaces,
  } = usePopularPlacePage();

  const [selectedPopularPlace, setSelectedPopularPlace] = useState<PopularPlace | null>(null);

  return (
    <>
      <MainTemplate
        title="Popular Places"
        useFitHeight
        button={{
          text: "Create",
          variant: "filled",
          onClick: handleOpenCreateModal,
          permission: {
            resource: Resource.POPULAR_PLACES,
            permission: Permission.CREATE,
          },
        }}
      >
        <StyledTableWrapper $isMobile={isMobile}>
          <TableTemplate<PopularPlace>
            headers={tableHeaders}
            data={popularPlaces}
            fetchDataFunction={() => { }}
            columnWidths={["10%", "30%", "30%", "30%"]} // No: 10%, Name: 30%, KH: 30%, ZH: 30%
            editable
            deletable
            showHeaderDeleteIcon={false}
            resource={Resource.POPULAR_PLACES}
            onPermissionError={showToast}
            onEdit={(popularPlace) => {
              setSelectedPopularPlace(popularPlace);
              handleOpenEditModal();
            }}
            onDelete={handleRowDelete}
            stickyHeader
            hasPagination={false}
          />
        </StyledTableWrapper>
      </MainTemplate>
      <CreatePopularPlaceModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        refetchPopularPlaces={refetchPopularPlaces}
      />

      {selectedPopularPlace && (
        <EditPopularPlaceModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          defaultValues={{
            name: selectedPopularPlace.name,
            name_kh: selectedPopularPlace.name_kh,
            name_zh: selectedPopularPlace.name_zh,
          }}
          popularPlaceId={selectedPopularPlace.id}
          refetchPopularPlaces={refetchPopularPlaces}
        />
      )}
    </>
  );
};

const StyledTableWrapper = styled.div<{ $isMobile?: boolean }>`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  
  ${({ $isMobile }) =>
    $isMobile
      ? `
      -webkit-overflow-scrolling: touch;
      max-height: calc(100vh - 200px);
      `
      : `
      max-height: calc(100vh - 250px);
      `}
`;
